import React, { useState } from 'react';
import { useAuth } from './auth-context';

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err: any) {
      setError(err.message || 'ログインに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" data-form="login" onSubmit={handleSubmit}>
        <h2>ログイン</h2>
        {error && <div className="login-error">{error}</div>}
        <div className="login-field" data-field="username">
          <label htmlFor="username">ユーザー名</label>
          <input
            id="username"
            data-testid="login-username"
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="login-field" data-field="password">
          <label htmlFor="password">パスワード</label>
          <input
            id="password"
            data-testid="login-password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" data-testid="login-submit" disabled={loading}>
          {loading ? 'ログイン中...' : 'ログイン'}
        </button>
      </form>
    </div>
  );
}
